(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["app-download-button"] && !Shopify.designMode) return;
  try {
    const DESKTOP_BREAKPOINT = 750;

  class AppDownloadButton extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      this.dialog = this.querySelector('dialog');

      if (!this.link || !this.dialog) return;

      this.closeButton = this.dialog.querySelector('.app-download-button__close');

      this.link.addEventListener('click', this.handleClick.bind(this));
      this.closeButton?.addEventListener('click', () => this.close());
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.close();
      });
    }

    handleClick(e) {
      if (window.innerWidth >= DESKTOP_BREAKPOINT) {
        e.preventDefault();
        this.dialog.showModal();
      }
    }

    close() {
      this.dialog.classList.add('dialog-closing');
      this.dialog.addEventListener('animationend', () => {
        this.dialog.classList.remove('dialog-closing');
        this.dialog.close();
      }, { once: true });
    }
  }

  customElements.define('app-download-button', AppDownloadButton);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["klarna-installments"] && !Shopify.designMode) return;
  try {
    class KlarnaInstallments extends HTMLElement {
    connectedCallback() {
      const section = this.closest('.shopify-section, dialog');
      if (!section) return;
      this._section = section;
      this._onVariantUpdate = this._onVariantUpdate.bind(this);
      section.addEventListener('variant:update', this._onVariantUpdate);
    }

    disconnectedCallback() {
      if (this._section) {
        this._section.removeEventListener('variant:update', this._onVariantUpdate);
      }
    }

    _onVariantUpdate(event) {
      const newBlock = event.detail.data.html.querySelector(
        `klarna-installments[data-block-id="${this.dataset.blockId}"]`
      );
      if (!newBlock) return;
      this.innerHTML = newBlock.innerHTML;
    }
  }

  if (!customElements.get('klarna-installments')) {
    customElements.define('klarna-installments', KlarnaInstallments);
  }
  } catch(e) { console.error(e); }
})();

})();
